import {
  TravelTypes,
  RatingCategories,
  SortingOptions,
  type QueryParams,
} from '@/modules/common/context/QueryParams/models';
import {
  type Schema,
  string,
  integer,
  boolean,
  array,
  enumerable,
  rooms as roomsSchema,
  filterPriceChart as filterPriceChartSchema,
  isoDate,
  price,
} from '@/modules/common/context/QueryParams/utils/querySchema';
import {isRoomViewType, isRoomAttributeType} from '@/utils/inviaType';

export const schema = {
  // search
  destinationId: string(),
  dateMin: isoDate(),
  dateMax: isoDate(),
  airports: array({schema: string()}),
  adults: integer({
    validate: (value) => value > 0,
  }),
  children: array({
    schema: integer(),
    validate: (value) => value >= 0,
  }),
  rooms: roomsSchema(),
  durationMin: integer({
    validate: (value) => value >= 0,
  }),
  durationMax: integer({
    validate: (value) => value >= 0,
  }),
  travelType: enumerable({
    _enum: TravelTypes,
  }),

  // filters
  priceMax: price({
    factor: 100,
    currency: import.meta.env.VITE_PORTAL_CURRENCY,
  }),
  priceMin: price({
    factor: 100,
    currency: import.meta.env.VITE_PORTAL_CURRENCY,
  }),
  categoryMin: integer({
    validate: (value) => value >= 0,
  }),
  ratingMin: enumerable({
    _enum: RatingCategories,
  }),
  hotelAttributes: array({schema: string()}),
  boardTypes: array({schema: string()}),
  roomTypes: array({schema: string()}),
  roomViews: array({
    schema: string(),
    validate: (value) => isRoomViewType(value),
  }),
  roomAttributes: array({
    schema: string(),
    validate: (value) => isRoomViewType(value) || isRoomAttributeType(value),
  }),
  tourOperators: array({schema: string()}),
  transportations: array({schema: string()}),
  duration: integer(), // @TODO validate?
  departureTimeMin: integer(), // @TODO validate?
  departureTimeMax: integer(), // @TODO validate?
  returnTimeMin: integer(), // @TODO validate?
  returnTimeMax: integer(), // @TODO validate?
  specials: array({schema: string()}),
  filterPriceChart: filterPriceChartSchema(),
  airlines: array({schema: string()}),
  arrivalAirports: array({schema: string()}),
  destinationIdFilter: string(),
  distanceAirportMax: integer({
    validate: (value) => value >= 0,
  }),
  distanceBeachMax: integer({
    validate: (value) => value >= 0,
  }),
  distanceCityCenterMax: integer({
    validate: (value) => value >= 0,
  }),
  distanceSkiSlopeMax: integer({
    validate: (value) => value >= 0,
  }),
  // sorting
  sortBy: enumerable({
    _enum: SortingOptions,
  }),

  // pagination
  offset: integer({
    validate: (value) => value >= 0,
  }),
  limit: integer({
    validate: (value) => value > 0,
  }),

  // other
  sea: string(),
  s: string(),
  featureInfo: boolean(),
} satisfies Record<keyof QueryParams, Schema<unknown>>;

export type QueryParamsSchema = typeof schema;
